<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <div style="display: flex">
                        <div style="flex: 1"></div>
                        <div>
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div style="height: 100%" class="sa-test">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            <span> {{ (currentPage - 1) * perPage + row.index + 1 }} </span>
                        </template>
                        <template v-slot:cell(nominativo)="{ item }">
                            <span>{{ item.pazienteCognome }} {{ item.pazienteNome }} ({{ item.statoAttuale }})</span>
                        </template>
                        <template v-slot:cell(dataOraProgrammata)="{ item }">
                            <span v-if="isUscitaProgrammata">{{ formatDateTime(item.dataOraUscitaProgrammata) }}</span>
                            <span v-else>{{ formatDateTime(item.dataOraEntrataProgrammata) }}</span>
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-container class="bv-example-row">
                                <template>
                                    <b-button v-if="row.item.dataOraUscita === null" v-b-tooltip.hover size="sm" variant="outline-purple" title="Registra Uscita" @click="onClickPresenzaUscita(row.item)" class="mr-1">
                                        <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
                                    </b-button>
                                    <b-button v-else v-b-tooltip.hover size="sm" variant="outline-danger" title="Registra Entrata" @click="onClickPresenzaEntrata(row.item)" class="sa-icon-rotate">
                                        <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
                                    </b-button>
                                </template>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
        <div class="sa-list-component-invisible">
            <rsa-scheda-ospite-uscite-edit-component ref="cmpRsaSchedaOspisteusciteEdit" @onSave="onSave" @onClose="onCloseModal"></rsa-scheda-ospite-uscite-edit-component>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
//import RsaRegistrazioneEntrateUsciteModalEditComponent from "../../rsagestioneospiti/components/RsaRegistrazioneEntrateUsciteModalEditComponent.vue";
import RsaSchedaOspiteUsciteEditComponent from "../../rsagestioneospiti/components/RsaSchedaOspiteUsciteEditComponent.vue";

export default {
    name: "RsaGestioneOspitiListComponent",
    mixins: [UtilityMixin],
    components: { /* RsaRegistrazioneEntrateUsciteModalEditComponent */ RsaSchedaOspiteUsciteEditComponent },
    props: {
        isUscitaProgrammata: {
            type: Boolean,
        },
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsapazientepresenze",
            pathResourceStampa: "/rsaprintdata/folder",
            filtroGestionePresenze: {},
            stampaReport: "",
            jsonDataAccettazione: null,
            items: [],
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 0.5rem",
                },
                /*    {
                    label: "Data Ricovero",
                    key: "dataRicovero",
                }, */
                {
                    label: "Nominativo",
                    key: "nominativo",
                    // sortable: true,
                },
                {
                    label: this.isUscitaProgrammata ? "Uscita Prog." : "Entrata Prog.",
                    key: "dataOraProgrammata",
                    sortable: true,
                },
                {
                    label: "Assente Nella Data",
                    key: "assenteNellaData",
                    formatter: (value) => {
                        if (value === true) return "SI";
                        if (value === false) return "NO";
                        return value === null || value === undefined ? "---" : value;
                    },
                },
                {
                    label: "Motivo",
                    key: "motivo",
                },
                {
                    label: "Note",
                    key: "allNotes",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    mounted() {},
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        init(tipoUscita, isUscitaProgrammata) {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroGestionePresenze"]) {
                me.filtroGestionePresenze = JSON.parse(sessionStorage["filtroGestionePresenze"]);
            }
            me.isUscitaProgrammata = isUscitaProgrammata;
            me.filtroGestionePresenze.tipo = tipoUscita;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResource + "/gestionepresenze", me.filtroGestionePresenze, me.resultResponse, me.resultError);
        },
        resultResponse(response) {
            let me = this;
            me.items = [];
            me.rows = response.data.data.recordsNumber;
            me.items = response.data.data.list;
            me.listKey++;
        },
        resultError(error) {
            console.log(error);
        },
        onClickConfigurazionePresenzaUscite(item) {
            let me = this;
            me.$router.push("/rsapaziente/uscite" + "?idAccettazione=" + item.id);
        },
        onClickPresenzaUscita(item) {
            let me = this;
            let jsonDataAccettazione = { statoAttuale: item.statoAttuale };
            let jsonData = { id: item.id, idAccettazione: item.idAccettazione, dataOraUscitaProgrammata: item.dataOraUscitaProgrammata, dataOraUscita: null, dataOraEntrataProgrammata: item.dataOraEntrataProgrammata, dataOraEntrata: null, tipo: "USCITA", motivo: item.motivo, assenteNellaData: null, noteUscitaProgrammata: item.noteUscitaProgrammata, noteEntrata: null, noteUscita: null };
            me.$refs.cmpRsaSchedaOspisteusciteEdit.init(jsonDataAccettazione, jsonData, false, false, true);
        },
        onClickPresenzaEntrata(item) {
            let me = this;
            let jsonDataAccettazione = { statoAttuale: item.statoAttuale };
            let jsonData = { id: item.id, idAccettazione: item.idAccettazione, dataOraUscitaProgrammata: item.dataOraUscitaProgrammata, dataOraUscita: item.dataOraUscita, dataOraEntrataProgrammata: item.dataOraEntrataProgrammata, dataOraEntrata: null, tipo: "ENTRATA", motivo: item.motivo, assenteNellaData: null, noteUscitaProgrammata: item.noteUscitaProgrammata, noteUscita: item.noteUscita, noteEntrata: null };
            me.$refs.cmpRsaSchedaOspisteusciteEdit.init(jsonDataAccettazione, jsonData, false, false, true);
        },
        onSavePresenza() {
            let me = this;
            me.loadData();
        },
        onClosePresenza() {},
        resetList() {
            let me = this;
            me.items = [];
        },
        onClickRicovera(item) {
            let me = this;
            me.$refs.cmpAccettazionePostiLettoModalEdit.show(item);
        },
        onAfterLoadData() {
            let me = this;
            me.$emit("afterLoadData");
            me.loadData();
        },
        onBeforeLoadData() {
            let me = this;
            me.$emit("beforeLoadData");
        },
        onSave() {
            let me = this;
            me.$emit("afterSaveData");
        },
        onCloseModal() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
<style>
.riga-assente {
    background-color: #74bce559 !important;
}
</style>
